import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export interface LevelBucketBounds {
  level: number;
  lower_bound: number;
  upper_bound: number;
}

export default class Levelbucket extends Model {
  [Type] = 'levelbucket' as const;

  @attr() declare levels: LevelBucketBounds[];
  @attr('number') declare type: number;
}
